import { InputLabel, Switch } from "@mui/material";
import { SelectWrapper } from "components/UiComponents";
import { Controller } from "react-hook-form";

export const ToggleField = ({ name, label, control }) => (
  <SelectWrapper>
    <InputLabel htmlFor={`toggle-${name}`}>{label}</InputLabel>
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <Switch
          id={`toggle-${name}`}
          checked={field.value}
          onChange={(e) => field.onChange(e.target.checked)}
          size="small"
        />
      )}
    />
  </SelectWrapper>
);
